import { render, staticRenderFns } from "./addBaseInfo.vue?vue&type=template&id=b5e367a8&scoped=true&"
import script from "./addBaseInfo.vue?vue&type=script&lang=js&"
export * from "./addBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./addBaseInfo.vue?vue&type=style&index=0&id=b5e367a8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5e367a8",
  null
  
)

export default component.exports